import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { rotateImageBase64 } from '@api/util/util';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ImageCroppedEvent } from 'ngx-image-cropper';

@Component({
  selector: 'app-modal-image-cropper',
  templateUrl: './modal-image-cropper.component.html'
})
export class ModalImageCropperComponent implements OnInit {
  @ViewChild('cropperContainer') cropperContainer: ElementRef;

  public base64ImageToCrop = '';
  public onCropImage: (base64Image: string) => void;

  public showCropper = false;
  public cropperHeight = 300;
  public loadingImage = true;

  private croppedBase64Image = '';

  constructor(public bsModalRef: BsModalRef) {}

  public async ngOnInit(): Promise<void> {
    if (!this.base64ImageToCrop) return;

    this.loadingImage = true;
    const sanitized = await this.sanitizeAndRotateImage(this.base64ImageToCrop);
    await this.prepareCropper(sanitized);
  }

  async sanitizeAndRotateImage(imageBase64: string): Promise<string> {
    const sanitized = await this.toBase64Png(imageBase64);
    const rotatedOnce = await rotateImageBase64(sanitized, 180);
    return rotateImageBase64(rotatedOnce, 180);
  }

  private toBase64Png(base64: string): Promise<string> {
    return new Promise(resolve => {
      const image = new Image();
      image.crossOrigin = 'Anonymous';
      image.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = image.width;
        canvas.height = image.height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(image, 0, 0);
        resolve(canvas.toDataURL('image/png'));
      };
      image.src = base64;
    });
  }

  async prepareCropper(rotatedBase64: string): Promise<void> {
    this.base64ImageToCrop = rotatedBase64;

    const imageSize = await this.getImageSize(rotatedBase64);
    const containerWidth = this.cropperContainer?.nativeElement?.offsetWidth || 400;
    const calculatedHeight = (imageSize.height * containerWidth) / imageSize.width;

    this.cropperHeight = Math.min(calculatedHeight, 500);
    this.showCropper = true;
    this.loadingImage = false;
  }

  getImageSize(base64: string): Promise<{ width: number; height: number }> {
    return new Promise(resolve => {
      const img = new Image();
      img.onload = () => resolve({ width: img.width, height: img.height });
      img.src = base64;
    });
  }

  public handleImageCropped(event: ImageCroppedEvent): void {
    this.croppedBase64Image = event.base64;
  }

  public handleCropImageClick(): void {
    if (this.onCropImage) {
      this.onCropImage(this.croppedBase64Image);
    }
    this.bsModalRef.hide();
  }
}
